export interface FAQItem {
    key: string;
    question: string;
    answer: string;
}

export const FAQ_DATA: FAQItem[] = [
    {
        key: 'rating-impact',
        question: 'How does my Klarity rating impact my visibility and ranking?',
        answer: `
            <ul>
                <li><strong>Higher rankings:</strong> Positive rating contribute to a higher ranking in Klarity&apos;s search results, making your profile more visible to potential patients.</li>
                <li><strong>Increased visibility:</strong> A strong online reputation with high ratings and positive reviews attracts more patients to your profile.</li>
                <li><strong>Traffic boost:</strong> At Klarity, we prioritize exceptional patient experiences. Providers with outstanding ratings will earn higher positions in our provider rankings, while those with consistently low ratings (below 3 stars) will face restrictions on patient traffic until they demonstrate significant improvement.</li>
            </ul>
        `,
    },
    {
        key: 'improve-practice',
        question: 'How can I use patient feedback to improve my practice?',
        answer: `
            <ul>
                <li><strong>Reputation dashboard:</strong> Access a personalized dashboard to track your ratings and reviews over time. Gain insights into patient satisfaction trends.</li>
                <li><strong>Respond to reviews:</strong> Engage with patients by responding to both positive and negative reviews. Show appreciation for positive reviews and address concerns professionally.</li>
                <li><strong>Helpful tips:</strong> Get guidance on crafting effective and appropriate responses to all types of reviews.</li>
                <li><strong>Patient-guided growth:</strong> Analyze patient reviews to identify areas for improvement, refine your approach, and deliver even better care.</li>
            </ul>
        `,
    },
    {
        key: 'grow-practice',
        question: 'How will Klarity reviews help me to grow my practice with positive reviews?',
        answer: `
            <ul>
                <li><strong>Amplify your success:</strong> We encourage satisfied patients to share their positive experiences on Trustpilot and Review.io.</li>
                <li><strong>Boost your ranking:</strong> Positive reviews improve your visibility in Klarity search results, making you more discoverable to potential patients.</li>
                <li><strong>Build trust:</strong> A strong online reputation with positive reviews demonstrates your commitment to quality care and helps attract new patients.</li>
                <li><strong>High standards:</strong> We may limit patient volume for providers with consistently low ratings to ensure a high-quality experience for all patients.</li>
            </ul>
        `,
    },
    {
        key: 'negative-reviews',
        question: 'What happens if I get negative reviews?',
        answer: `
            <ul>
                <li><strong>Public vs. private reviews:</strong> Patients can choose to make their reviews public (visible on Klarity) or private (visible only to you). We encourage patients to leave negative feedback privately, allowing you to address their concerns directly.</li>
                <li><strong>Reply to a negative review:</strong> You have 30 days to reply, and we recommend responding as soon as possible to demonstrate your commitment to patient satisfaction.</li>
                <li><strong>Reply visibility (public reviews):</strong> If a patient makes their review public and requests a reply, you can choose to make your reply public as well (visible on Klarity) or keep it private between you and the patient. Make sure you won&apos;t expose patient&apos;s person information in a public review.</li>
                <li><strong>Disputed reviews:</strong> You can dispute any negative review. Reviews will only be removed from Helloklarity.com if they contain offensive language, PHI, false identity, spam, or a conflict of interest. All other disputed reviews will remain visible, but the scores won't count toward your weighted average rating.</li>
                <li><strong>Complaint option:</strong> If a patient has a serious concern, they can choose to file a formal complaint, which will be reviewed by our team.</li>
            </ul>
        `,
    },
    {
        key: 'remove-review',
        question: 'Can I request to remove a review?',
        answer: `
            <p>If you believe a patient review has been incorrectly attributed to your profile, you may dispute it. Our team will review the case, and if confirmed as a misattribution, we will remove the review from your page.</p>
        `,
    },
    {
        key: 'disagree-review',
        question: 'What if I disagree with a review about my medical judgment or prescription decision?',
        answer: `
            <p>These reviews cannot be removed, but you can post a HIPAA-safe public response within 30 days to share your perspective.</p>
        `,
    },
];

